import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};
export default function AccountStats({ children }: Props) {
  return <div className="grid grid-cols-2 gap-1.5 w-full mt-5">{children}</div>;
}
